import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import { Confirm, FileList } from './sharedComponents';
import * as fileActions from '../fileActions';
import { getCollection, ModelCollection } from '../store';
export default class ContractorFilesEdit extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = ContractorFilesEdit.getDerivedStateFromProps(this.props, {});

		this.uploadFiles = this.uploadFiles.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
	}

	componentDidMount () {
		fileActions.fetchFilesForContractor({ contractor: this.props.contractor });
	}
	
	// UNSAFE_componentWillReceiveProps (nextProps) {
	// 	this.setState(this.getStateFromProps(nextProps));
	// }

	static getDerivedStateFromProps (props, currentState) {
		const { store } = componentServices;
		const { contractor } = props;
		const state = _.assign({}, currentState);

		state.contractorFiles = getCollection({ store,  collection: ModelCollection.files }).filter(f => {
			return f.rootKey === contractor.key;
		}).toArray();

		return state;
	}

	updateModel (updater, options) {
		this.props.updateModel(model => {
			updater(model);
		}, options);
	}

	uploadFiles (files, relatedType, relatedTypeKey) {
		const { contractor } = this.props;

		_.forEach(files, f => {
			fileActions.enqueueUpload({ rootKey: contractor.key, rootType: 'contractor', file: f, relatedType: relatedType, relatedTypeKey: relatedTypeKey });
		});
	}

	deleteFile (file) {
		const deleter = () => {
			fileActions.deleteFile({ file: file });
			actions.popModal();
		};
		const title = `Delete ${file.name}?`;

		actions.pushModal({
			component: <Confirm title={title} message="Are you sure you want to delete this file?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	render () {
		const { emptyTitle } = this.props;
		const { contractorFiles } = this.state;

		return <FileList emptyTitle = { emptyTitle } title= "Files" hideSource={ true } list={ contractorFiles } uploadFiles={ this.uploadFiles } deleteFile={ this.deleteFile } />;
	}
}